<div class="callback-container">
  <div class="callback-card">
    @if (!error) {
    <div class="spinner"></div>
    } @else {
    <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <circle cx="12" cy="12" r="10" stroke-width="2" />
      <line x1="15" y1="9" x2="9" y2="15" stroke-width="2" />
      <line x1="9" y1="9" x2="15" y2="15" stroke-width="2" />
    </svg>
    }

    <p class="callback-message" [class.error]="error">{{ message }}</p>

    @if (error) {
    <p class="redirect-message">Redirecting to login...</p>
    }
  </div>
</div>